<form [formGroup]="form" (ngSubmit)="save()">
  <h1 mat-dialog-title>Cambio fecha recepción</h1>
  <div>

    <mat-form-field class="medium-width">
      <input matInput autocomplete="off" formControlName="date" [matDatepicker]="pickerFrom" placeholder="Fecha" required>
      <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerFrom></mat-datepicker>
      <mat-error *ngIf="f.date.errors && f.date.errors.required">
          Ingrese la fecha
      </mat-error>
  </mat-form-field>


  </div>
  <div class="clearfix">
    <div class="pull-right">
      <button *ngIf="!loadingAction" mat-button type="submit">Aceptar</button>
      <button *ngIf="!loadingAction" mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
    </div>
  </div>
</form>
